import api from './api';

export interface User {
  id: number;
  name: string;
  wechat_userid: string;
  department?: string;
  email?: string;
  avatar_url?: string;
  is_admin: boolean;
}

export interface LoginResponse {
  access_token: string;
  token_type: string;
  user: User;
}

export interface OAuthUrlResponse {
  oauth_url: string;
}

export const authService = {
  // 企微登录
  async login(code: string): Promise<LoginResponse> {
    const response = await api.post('/auth/wechat/login', null, {
      params: { code }
    });
    return response.data;
  },

  // 获取用户信息
  async getProfile(): Promise<User> {
    const response = await api.get('/auth/profile');
    return response.data;
  },

  // 退出登录
  async logout(): Promise<void> {
    await api.post('/auth/logout');
  },

  // 获取企微OAuth授权URL
  async getWeChatOAuthUrl(redirectUri: string): Promise<OAuthUrlResponse> {
    const response = await api.get('/auth/wechat/oauth-url', {
      params: { redirect_uri: redirectUri }
    });
    return response.data;
  },
};
